import type { GitRef, ProjectTemplateResource } from "@octopusdeploy/octopus-server-client";
import { links } from "@octopusdeploy/portal-routes";
import * as React from "react";
import { useEffect, useReducer } from "react";
import { useSpaceAwareNavigation } from "~/components/Navigation/SpaceAwareNavigation/useSpaceAwareNavigation";
import CreateNewProjectTemplate from "./CreateNewProjectTemplate";
import { projectTemplateStatusActions, projectTemplateStatusReducer, initialProjectTemplateStatusState } from "./ProjectTemplateStatus";
export interface NewProjectTemplateWizardProps {
    gitRef: GitRef;
    closeDialog: () => void;
}
function NewProjectTemplateWizard({ gitRef, closeDialog }: NewProjectTemplateWizardProps) {
    const navigate = useSpaceAwareNavigation();
    const [projectTemplateStatusState, projectTemplateStatusDispatch] = useReducer(projectTemplateStatusReducer, initialProjectTemplateStatusState);
    useEffect(() => {
        projectTemplateStatusDispatch({ type: projectTemplateStatusActions.projectTemplateStatusInitiated });
    }, []);
    const projectTemplateCreated = (projectTemplate: ProjectTemplateResource) => {
        projectTemplateStatusDispatch({ type: projectTemplateStatusActions.projectTemplateStatusCreated });
        const url = links.projectTemplateDeploymentProcessPage.generateUrl({ slug: projectTemplate.Slug, gitRef: projectTemplate.GitRef });
        navigate.navigate(url);
    };
    return (<CreateNewProjectTemplate gitRef={gitRef} next={projectTemplateCreated} close={() => {
            closeDialog();
        }} projectTemplateStatus={{
            state: projectTemplateStatusState,
            dispatch: projectTemplateStatusDispatch,
        }}/>);
}
export { NewProjectTemplateWizard };
